import React from 'react';
import { MOBILE_COLORS, MOBILE_BORDERS } from '../../styles/mobileTheme';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MobilePercentBadge = ({
  value,
  size = 'md', // sm, md, lg
  showIcon = true,
  style = {},
}) => {
  const numValue = typeof value === 'number' ? value : parseFloat(value) || 0;
  const isPositive = numValue >= 0;
  
  const getSizeStyles = () => {
    switch (size) {
      case 'sm':
        return { padding: '2px 6px', fontSize: '11px', iconSize: 10 };
      case 'lg':
        return { padding: '6px 12px', fontSize: '14px', iconSize: 16 };
      case 'md':
      default:
        return { padding: '4px 8px', fontSize: '12px', iconSize: 12 };
    }
  };

  const sizeStyles = getSizeStyles();
  
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: sizeStyles.padding,
        fontSize: sizeStyles.fontSize,
        fontWeight: '600',
        borderRadius: MOBILE_BORDERS.radius.sm,
        backgroundColor: isPositive ? MOBILE_COLORS.successMuted : MOBILE_COLORS.dangerMuted,
        color: isPositive ? MOBILE_COLORS.success : MOBILE_COLORS.danger,
        ...style,
      }}
    >
      {showIcon && (
        isPositive 
          ? <TrendingUp size={sizeStyles.iconSize} />
          : <TrendingDown size={sizeStyles.iconSize} />
      )}
      {isPositive ? '+' : ''}{numValue.toFixed(2)}%
    </span>
  );
};

export default MobilePercentBadge;
